<template>
  <div class="popup-update">
    <p class="lead">A new version is available</p>
    <p>Refresh to load it?</p>
    <div class="popup-action">
      <button
        class="btn btn-sm btn-primary"
        @click="update">
        Update
      </button>
      <button
        class="btn btn-sm btn-outline-primary"
        @click="close">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupUpdate',

  methods: {
    close() {
      this.$emit('close');
    },

    update() {
      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-update {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-left: 0.5rem solid $color-secondary;
  border-radius: 0.25rem;
  box-shadow: 3px 0 6px rgba(0,0,0,.2);
  z-index: 100;

  p {
    font-size: 13px;
    margin-bottom: 0.5rem;

    &.lead {
      font-size: 0.875rem;
      font-weight: 500;
    }
  }

  .popup-action {
    display: flex;
    justify-content: flex-start;
    margin-top: 0.75rem;

    .btn {
      margin-right: 0.5rem;
      text-transform: uppercase;
      font-size: 0.675rem;
      font-weight: 500;
    }
  }
}
</style>
